import { convertToLocale } from "@lib/util/money"
import { HttpTypes } from "@medusajs/types"

type LineItemUnitPriceProps = {
  item: HttpTypes.StoreCartLineItem | HttpTypes.StoreOrderLineItem
  style?: "default" | "tight"
  currencyCode: string
}

const LineItemUnitPrice = ({
  item,
  style = "default",
  currencyCode,
}: LineItemUnitPriceProps) => {
  const total = item.total ?? 0
  const originalTotal = item.original_total ?? 0
  const hasReducedPrice = total < originalTotal

  const percentage_diff = Math.round(
    ((originalTotal - total) / originalTotal) * 100
  )

  return (
    <div className="flex flex-col text-gray-400 justify-center h-full">
      {hasReducedPrice && (
        <>
          <p>
            {style === "default" && (
              <span className="text-gray-400">Original: </span>
            )}
            <span
              className="line-through"
              data-testid="product-unit-original-price"
            >
              {convertToLocale({
                amount: originalTotal / item.quantity,
                currency_code: currencyCode,
              })}
            </span>
          </p>
          {style === "default" && (
            <span className="text-brand-accent font-semibold">
              -{percentage_diff}%
            </span>
          )}
        </>
      )}
      <span
        className={`text-sm ${hasReducedPrice ? "text-brand-accent font-semibold" : "text-gray-900"}`}
        data-testid="product-unit-price"
      >
        {convertToLocale({
          amount: total / item.quantity,
          currency_code: currencyCode,
        })}
      </span>
    </div>
  )
}

export default LineItemUnitPrice
